const fakeBranchData = {
  "Branch 1": {
    color: "#00C49F",
    January: [
      { day: 1, price: 155 },
      { day: 2, price: 149 },
      { day: 3, price: 88 },
      { day: 4, price: 135 },
      { day: 5, price: 457 },
      { day: 6, price: 195 },
      { day: 7, price: 373 },
      { day: 8, price: 91 },
      { day: 9, price: 147 },
      { day: 10, price: 270 },
      { day: 11, price: 285 },
      { day: 12, price: 127 },
      { day: 13, price: 430 },
      { day: 14, price: 299 },
      { day: 15, price: 172 },
    ],
    February: [
      { day: 1, price: 274 },
      { day: 2, price: 265 },
      { day: 3, price: 479 },
      { day: 4, price: 195 },
      { day: 5, price: 102 },
      { day: 6, price: 386 },
      { day: 7, price: 228 },
      { day: 8, price: 266 },
      { day: 9, price: 295 },
      { day: 10, price: 98 },
      { day: 11, price: 465 },
      { day: 12, price: 122 },
      { day: 13, price: 183 },
      { day: 14, price: 190 },
      { day: 15, price: 354 },
    ],
    March: [
      { day: 1, price: 263 },
      { day: 2, price: 464 },
      { day: 3, price: 214 },
      { day: 4, price: 147 },
      { day: 5, price: 499 },
      { day: 6, price: 397 },
      { day: 7, price: 225 },
      { day: 8, price: 101 },
      { day: 9, price: 59 },
      { day: 10, price: 161 },
      { day: 11, price: 302 },
      { day: 12, price: 470 },
      { day: 13, price: 381 },
      { day: 14, price: 72 },
      { day: 15, price: 211 },
    ],
    April: [
      { day: 1, price: 264 },
      { day: 2, price: 85 },
      { day: 3, price: 297 },
      { day: 4, price: 125 },
      { day: 5, price: 102 },
      { day: 6, price: 221 },
      { day: 7, price: 460 },
      { day: 8, price: 113 },
      { day: 9, price: 413 },
      { day: 10, price: 347 },
      { day: 11, price: 214 },
      { day: 12, price: 301 },
      { day: 13, price: 232 },
      { day: 14, price: 243 },
      { day: 15, price: 267 },
    ],
    May: [
      { day: 1, price: 412 },
      { day: 2, price: 208 },
      { day: 3, price: 465 },
      { day: 4, price: 376 },
      { day: 5, price: 234 },
      { day: 6, price: 163 },
      { day: 7, price: 194 },
      { day: 8, price: 144 },
      { day: 9, price: 376 },
      { day: 10, price: 84 },
      { day: 11, price: 188 },
      { day: 12, price: 365 },
      { day: 13, price: 469 },
      { day: 14, price: 453 },
      { day: 15, price: 153 },
    ],
    June: [
      { day: 1, price: 93 },
      { day: 2, price: 211 },
      { day: 3, price: 182 },
      { day: 4, price: 249 },
      { day: 5, price: 350 },
      { day: 6, price: 467 },
      { day: 7, price: 273 },
      { day: 8, price: 236 },
      { day: 9, price: 174 },
      { day: 10, price: 295 },
      { day: 11, price: 114 },
      { day: 12, price: 387 },
      { day: 13, price: 450 },
      { day: 14, price: 226 },
      { day: 15, price: 289 },
    ],
  },
  "Branch 2": {
    color: "#FFBB28",
    January: [
      { day: 1, price: 312 },
      { day: 2, price: 159 },
      { day: 3, price: 442 },
      { day: 4, price: 227 },
      { day: 5, price: 368 },
      { day: 6, price: 97 },
      { day: 7, price: 256 },
      { day: 8, price: 314 },
      { day: 9, price: 143 },
      { day: 10, price: 210 },
      { day: 11, price: 403 },
      { day: 12, price: 121 },
      { day: 13, price: 480 },
      { day: 14, price: 263 },
      { day: 15, price: 374 },
    ],
    February: [
      { day: 1, price: 248 },
      { day: 2, price: 107 },
      { day: 3, price: 327 },
      { day: 4, price: 178 },
      { day: 5, price: 364 },
      { day: 6, price: 420 },
      { day: 7, price: 298 },
      { day: 8, price: 135 },
      { day: 9, price: 231 },
      { day: 10, price: 396 },
      { day: 11, price: 170 },
      { day: 12, price: 289 },
      { day: 13, price: 472 },
      { day: 14, price: 382 },
      { day: 15, price: 215 },
    ],
    March: [
      { day: 1, price: 322 },
      { day: 2, price: 138 },
      { day: 3, price: 405 },
      { day: 4, price: 254 },
      { day: 5, price: 143 },
      { day: 6, price: 345 },
      { day: 7, price: 488 },
      { day: 8, price: 198 },
      { day: 9, price: 173 },
      { day: 10, price: 366 },
      { day: 11, price: 118 },
      { day: 12, price: 490 },
      { day: 13, price: 249 },
      { day: 14, price: 152 },
      { day: 15, price: 384 },
    ],
    April: [
      { day: 1, price: 394 },
      { day: 2, price: 202 },
      { day: 3, price: 153 },
      { day: 4, price: 428 },
      { day: 5, price: 172 },
      { day: 6, price: 349 },
      { day: 7, price: 198 },
      { day: 8, price: 410 },
      { day: 9, price: 305 },
      { day: 10, price: 210 },
      { day: 11, price: 467 },
      { day: 12, price: 300 },
      { day: 13, price: 214 },
      { day: 14, price: 122 },
      { day: 15, price: 366 },
    ],
    May: [
      { day: 1, price: 476 },
      { day: 2, price: 248 },
      { day: 3, price: 365 },
      { day: 4, price: 314 },
      { day: 5, price: 179 },
      { day: 6, price: 453 },
      { day: 7, price: 231 },
      { day: 8, price: 289 },
      { day: 9, price: 404 },
      { day: 10, price: 167 },
      { day: 11, price: 378 },
      { day: 12, price: 195 },
      { day: 13, price: 283 },
      { day: 14, price: 317 },
      { day: 15, price: 344 },
    ],
    June: [
      { day: 1, price: 158 },
      { day: 2, price: 408 },
      { day: 3, price: 194 },
      { day: 4, price: 486 },
      { day: 5, price: 297 },
      { day: 6, price: 376 },
      { day: 7, price: 233 },
      { day: 8, price: 99 },
      { day: 9, price: 260 },
      { day: 10, price: 472 },
      { day: 11, price: 186 },
      { day: 12, price: 123 },
      { day: 13, price: 145 },
      { day: 14, price: 398 },
      { day: 15, price: 344 },
    ],
  },
  "Branch 3": {
    color: "#FF8042",
    January: [
      { day: 1, price: 421 },
      { day: 2, price: 203 },
      { day: 3, price: 312 },
      { day: 4, price: 98 },
      { day: 5, price: 187 },
      { day: 6, price: 476 },
      { day: 7, price: 132 },
      { day: 8, price: 344 },
      { day: 9, price: 239 },
      { day: 10, price: 493 },
      { day: 11, price: 161 },
      { day: 12, price: 266 },
      { day: 13, price: 399 },
      { day: 14, price: 185 },
      { day: 15, price: 329 },
    ],
    February: [
      { day: 1, price: 322 },
      { day: 2, price: 149 },
      { day: 3, price: 488 },
      { day: 4, price: 194 },
      { day: 5, price: 212 },
      { day: 6, price: 399 },
      { day: 7, price: 306 },
      { day: 8, price: 181 },
      { day: 9, price: 259 },
      { day: 10, price: 492 },
      { day: 11, price: 133 },
      { day: 12, price: 365 },
      { day: 13, price: 284 },
      { day: 14, price: 314 },
      { day: 15, price: 218 },
    ],
    March: [
      { day: 1, price: 289 },
      { day: 2, price: 167 },
      { day: 3, price: 336 },
      { day: 4, price: 495 },
      { day: 5, price: 142 },
      { day: 6, price: 275 },
      { day: 7, price: 407 },
      { day: 8, price: 202 },
      { day: 9, price: 312 },
      { day: 10, price: 166 },
      { day: 11, price: 458 },
      { day: 12, price: 190 },
      { day: 13, price: 369 },
      { day: 14, price: 107 },
      { day: 15, price: 491 },
    ],
    April: [
      { day: 1, price: 392 },
      { day: 2, price: 170 },
      { day: 3, price: 261 },
      { day: 4, price: 117 },
      { day: 5, price: 404 },
      { day: 6, price: 365 },
      { day: 7, price: 294 },
      { day: 8, price: 154 },
      { day: 9, price: 430 },
      { day: 10, price: 382 },
      { day: 11, price: 296 },
      { day: 12, price: 113 },
      { day: 13, price: 459 },
      { day: 14, price: 185 },
      { day: 15, price: 306 },
    ],
    May: [
      { day: 1, price: 128 },
      { day: 2, price: 312 },
      { day: 3, price: 499 },
      { day: 4, price: 101 },
      { day: 5, price: 277 },
      { day: 6, price: 384 },
      { day: 7, price: 217 },
      { day: 8, price: 429 },
      { day: 9, price: 153 },
      { day: 10, price: 361 },
      { day: 11, price: 256 },
      { day: 12, price: 471 },
      { day: 13, price: 187 },
      { day: 14, price: 242 },
      { day: 15, price: 398 },
    ],
    June: [
      { day: 1, price: 267 },
      { day: 2, price: 134 },
      { day: 3, price: 220 },
      { day: 4, price: 478 },
      { day: 5, price: 351 },
      { day: 6, price: 205 },
      { day: 7, price: 309 },
      { day: 8, price: 399 },
      { day: 9, price: 146 },
      { day: 10, price: 366 },
      { day: 11, price: 284 },
      { day: 12, price: 143 },
      { day: 13, price: 426 },
      { day: 14, price: 107 },
      { day: 15, price: 314 },
    ],
  },
  "Branch 4": {
    color: "#8884d8",
    January: [
      { day: 1, price: 243 },
      { day: 2, price: 197 },
      { day: 3, price: 392 },
      { day: 4, price: 158 },
      { day: 5, price: 489 },
      { day: 6, price: 364 },
      { day: 7, price: 117 },
      { day: 8, price: 413 },
      { day: 9, price: 341 },
      { day: 10, price: 280 },
      { day: 11, price: 124 },
      { day: 12, price: 206 },
      { day: 13, price: 309 },
      { day: 14, price: 457 },
      { day: 15, price: 328 },
    ],
    February: [
      { day: 1, price: 222 },
      { day: 2, price: 156 },
      { day: 3, price: 413 },
      { day: 4, price: 178 },
      { day: 5, price: 495 },
      { day: 6, price: 283 },
      { day: 7, price: 356 },
      { day: 8, price: 239 },
      { day: 9, price: 407 },
      { day: 10, price: 164 },
      { day: 11, price: 194 },
      { day: 12, price: 482 },
      { day: 13, price: 127 },
      { day: 14, price: 387 },
      { day: 15, price: 343 },
    ],
    March: [
      { day: 1, price: 199 },
      { day: 2, price: 275 },
      { day: 3, price: 316 },
      { day: 4, price: 412 },
      { day: 5, price: 365 },
      { day: 6, price: 207 },
      { day: 7, price: 439 },
      { day: 8, price: 189 },
      { day: 9, price: 495 },
      { day: 10, price: 174 },
      { day: 11, price: 143 },
      { day: 12, price: 387 },
      { day: 13, price: 128 },
      { day: 14, price: 342 },
      { day: 15, price: 267 },
    ],
    April: [
      { day: 1, price: 283 },
      { day: 2, price: 457 },
      { day: 3, price: 246 },
      { day: 4, price: 114 },
      { day: 5, price: 393 },
      { day: 6, price: 358 },
      { day: 7, price: 321 },
      { day: 8, price: 155 },
      { day: 9, price: 275 },
      { day: 10, price: 118 },
      { day: 11, price: 477 },
      { day: 12, price: 205 },
      { day: 13, price: 189 },
      { day: 14, price: 433 },
      { day: 15, price: 299 },
    ],
    May: [
      { day: 1, price: 401 },
      { day: 2, price: 302 },
      { day: 3, price: 349 },
      { day: 4, price: 241 },
      { day: 5, price: 414 },
      { day: 6, price: 189 },
      { day: 7, price: 128 },
      { day: 8, price: 369 },
      { day: 9, price: 214 },
      { day: 10, price: 490 },
      { day: 11, price: 221 },
      { day: 12, price: 278 },
      { day: 13, price: 137 },
      { day: 14, price: 328 },
      { day: 15, price: 453 },
    ],
    June: [
      { day: 1, price: 164 },
      { day: 2, price: 423 },
      { day: 3, price: 372 },
      { day: 4, price: 287 },
      { day: 5, price: 118 },
      { day: 6, price: 412 },
      { day: 7, price: 248 },
      { day: 8, price: 366 },
      { day: 9, price: 158 },
      { day: 10, price: 493 },
      { day: 11, price: 177 },
      { day: 12, price: 398 },
      { day: 13, price: 309 },
      { day: 14, price: 236 },
      { day: 15, price: 324 },
    ],
  },
  "Branch 5": {
    color: "#82ca9d",
    January: [
      { day: 1, price: 431 },
      { day: 2, price: 266 },
      { day: 3, price: 341 },
      { day: 4, price: 183 },
      { day: 5, price: 299 },
      { day: 6, price: 132 },
      { day: 7, price: 475 },
      { day: 8, price: 384 },
      { day: 9, price: 150 },
      { day: 10, price: 244 },
      { day: 11, price: 398 },
      { day: 12, price: 124 },
      { day: 13, price: 353 },
      { day: 14, price: 211 },
      { day: 15, price: 317 },
    ],
    February: [
      { day: 1, price: 265 },
      { day: 2, price: 185 },
      { day: 3, price: 498 },
      { day: 4, price: 132 },
      { day: 5, price: 407 },
      { day: 6, price: 316 },
      { day: 7, price: 278 },
      { day: 8, price: 122 },
      { day: 9, price: 437 },
      { day: 10, price: 203 },
      { day: 11, price: 376 },
      { day: 12, price: 148 },
      { day: 13, price: 423 },
      { day: 14, price: 266 },
      { day: 15, price: 329 },
    ],
    March: [
      { day: 1, price: 344 },
      { day: 2, price: 187 },
      { day: 3, price: 225 },
      { day: 4, price: 451 },
      { day: 5, price: 271 },
      { day: 6, price: 316 },
      { day: 7, price: 170 },
      { day: 8, price: 134 },
      { day: 9, price: 283 },
      { day: 10, price: 464 },
      { day: 11, price: 214 },
      { day: 12, price: 143 },
      { day: 13, price: 497 },
      { day: 14, price: 392 },
      { day: 15, price: 219 },
    ],
    April: [
      { day: 1, price: 239 },
      { day: 2, price: 305 },
      { day: 3, price: 183 },
      { day: 4, price: 475 },
      { day: 5, price: 124 },
      { day: 6, price: 386 },
      { day: 7, price: 260 },
      { day: 8, price: 145 },
      { day: 9, price: 467 },
      { day: 10, price: 318 },
      { day: 11, price: 191 },
      { day: 12, price: 403 },
      { day: 13, price: 349 },
      { day: 14, price: 223 },
      { day: 15, price: 312 },
    ],
    May: [
      { day: 1, price: 487 },
      { day: 2, price: 208 },
      { day: 3, price: 251 },
      { day: 4, price: 331 },
      { day: 5, price: 167 },
      { day: 6, price: 435 },
      { day: 7, price: 241 },
      { day: 8, price: 128 },
      { day: 9, price: 492 },
      { day: 10, price: 286 },
      { day: 11, price: 319 },
      { day: 12, price: 132 },
      { day: 13, price: 398 },
      { day: 14, price: 209 },
      { day: 15, price: 456 },
    ],
    June: [
      { day: 1, price: 379 },
      { day: 2, price: 186 },
      { day: 3, price: 495 },
      { day: 4, price: 240 },
      { day: 5, price: 411 },
      { day: 6, price: 157 },
      { day: 7, price: 318 },
      { day: 8, price: 421 },
      { day: 9, price: 211 },
      { day: 10, price: 368 },
      { day: 11, price: 147 },
      { day: 12, price: 266 },
      { day: 13, price: 324 },
      { day: 14, price: 189 },
      { day: 15, price: 453 },
    ],
  },
};

export default fakeBranchData;
